import { createServerFn } from '@tanstack/react-start'
import { getAuthSession, sessionConfig } from './auth'
import { clearSession } from '@tanstack/react-start/server'

export const getSessionUser = createServerFn({ method: 'GET' }).handler(
  async () => {
    const session = await getAuthSession()

    if (!session.data.githubUser) {
      return null
    }

    const allowed = (process.env.ALLOWED_GITHUB_USERS || '')
      .split(',')
      .map((u) => u.trim().toLowerCase())

    if (!allowed.includes(session.data.githubUser.toLowerCase())) {
      return null
    }

    return {
      user: session.data.githubUser,
      avatarUrl: session.data.avatarUrl,
    }
  },
)

export const logoutAction = createServerFn({ method: 'POST' }).handler(
  async () => {
    await clearSession(sessionConfig)
    return { success: true }
  },
)
